import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query. Used for tablet vs desktop configurator layout.
 */
export function useMediaQuery(query) {
  const getMatch = () => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const media = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);
    setMatches(media.matches);
    if (media.addEventListener) {
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    }
    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, [query]);

  return matches;
}

/** Tablets and smaller laptops: tabbed configurator instead of 3 side-by-side columns. */
export function useConfiguratorCompactLayout() {
  return useMediaQuery('(max-width: 1279px)');
}
